import { Component, HostListener } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ViajeDTO } from '../../../dtos/viaje.dto';
import { HttpErrorResponse } from '@angular/common/http';
import { EventService } from '../../services/event.service';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../services/api.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-modal-cancelar-viaje',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-cancelar-viaje.component.html',
  styleUrl: './modal-cancelar-viaje.component.scss'
})
export class ModalCancelarViajeComponent {
  viaje: ViajeDTO | null = null;
  motivo: string = '';
  observaciones: string = '';
  enviando: boolean = false;
  motivosCancelacion = [
    'NINGUN BUS DISPONIBLE',
    'NINGUN CONDUCTOR DISPONIBLE',
    'FALLA MECÁNICA',
    // 'CONDUCTOR NO DISPONIBLE',
    'CAMBIO DE PROGRAMACIÓN',
    'OTROS'
  ];

  constructor(public bsModalRef: BsModalRef,
    public eventService: EventService,
    public apiService: ApiService,
    private toastr: ToastrService,
    private userService: UserService) {}

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.close();
  }

  cancelarViaje() {
    this.enviando = true;
    this.apiService.putCancelarViajeDespachador(
      this.viaje.uuid,
      this.motivo,
      this.observaciones
    ).subscribe(
      (resp) => this.cancelarViajeSuccess(resp),
      (error) => this.cancelarViajeError(error)
    );
  }

  cancelarViajeSuccess(resp: any){
    console.log({ resp })
    this.eventService.publish('CANCELAR_VIAJE_EVENT');
    this.enviando = false;
    this.close();
  }

  cancelarViajeError(error : HttpErrorResponse){
    console.log('error cancelando viaje', error);
    this.enviando = false;
    this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  close() {
    this.bsModalRef.hide();
  }

  tienePermisoCancelarViaje(): boolean {
    return this.userService.tienePermiso('VIAJE_CANCELAR');
  }
}
